import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['field']

    clearAll() {
      this.element.classList.add("hidden")
      this.fieldTargets.forEach((field) => { field.value = "" })
    }
}